
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabandbusserviceinshirwal() {



    const cardData =
    {
        keyword: 'Corporate Cab and Bus Services in Shirwal MIDC',
        heading: 'etravo : Corporate Cab and Bus Services in Shirwal MIDC',
        headingDescription: 'eTravo offers reliable and professional Corporate Cab and Bus Services in Shirwal MIDC, tailored to meet the daily transportation needs of manufacturing plants and industrial units. Whether it’s executive cabs for business travel or high-capacity buses for employee shift transport, our services ensure punctuality, safety, and convenience. With a fleet of well-maintained vehicles, trained drivers, and GPS tracking systems, eTravo supports smooth and efficient mobility solutions for corporates operating in the Shirwal MIDC region.',

        top: 'Top Places to Visit in Shirwal with etravo',
    "topPlaces": [
    {
      "title": "Shirwal Buddhist Caves",
      "description": "A group of 15 ancient Buddhist caves, including one Chaitya and 14 Viharas, dating back to the early phase of Buddhism. These caves are located near the Bhor exit off the Mumbai-Bangalore highway and offer a serene spot for history enthusiasts and trekkers."
    },
    {
      "title": "Subhanmangal Fort",
      "description": "A small fort of historical significance, known as the site of the first open battle between Chhatrapati Shivaji Maharaj's forces and the Adilshahi army. Though the fort's structures are modest, it holds great importance in Maratha history."
    },
    {
      "title": "Veer Dam",
      "description": "Constructed on the Nira River, Veer Dam is a popular spot for bird watching, especially during the migratory season. The area is rich in avifauna, making it a haven for nature lovers and photographers."
    },
    {
      "title": "Kedareshwar Temple",
      "description": "A revered temple dedicated to Lord Shiva, located in the heart of Shirwal. The temple is known for its spiritual ambiance and attracts devotees from the surrounding regions."
    },
    {
      "title": "Savitribai Phule Smarak",
      "description": "A memorial dedicated to the social reformer Savitribai Phule, highlighting her contributions to women's education and empowerment in India."
    },
    {
      "title": "Baneshwar Temple",
      "description": "Situated approximately 16 km from Shirwal, this ancient temple is nestled amidst dense forests and is a popular spot for picnics and nature walks."
    },
    {
      "title": "Purandar Fort",
      "description": "Located about 15 km from Shirwal, Purandar Fort is a historic site offering panoramic views and trekking opportunities. It played a significant role during the Maratha Empire."
    },
    {
      "title": "Shree Kshetra Narayanpur Datta Mandir",
      "description": "A spiritual destination located around 17 km from Shirwal, this temple is dedicated to Lord Dattatreya and is known for its tranquil surroundings."
    },
    {
      "title": "Shrinath Mhaskoba Mandir, Veer",
      "description": "Approximately 12 km from Shirwal, this temple is dedicated to Lord Mhaskoba and is a significant place of worship for the local community."
    },
    {
      "title": "Mandhardevi Temple",
      "description": "Located about 16 km from Shirwal, this hilltop temple offers scenic views and is a popular pilgrimage site, especially during the annual fair."
    }
  ],
   "services": [
    {
      "name": "Corporate Cab & Bus Rental Shirwal MIDC",
      "description": "eTravo offers corporate cab and bus rental services tailored for businesses in Shirwal MIDC. Our fleet includes air-conditioned cabs, tempo travellers, and large buses ideal for daily commutes, inter-facility transfers, and executive travel. Whether your requirement is for short-term use or a long-term transport contract, we ensure reliable service, professional drivers, and flexible booking options that support operational efficiency."
    },
    {
      "name": "Employee Shuttle Buses for Industries in Shirwal",
      "description": "Designed specifically for industrial zones, eTravo provides employee shuttle bus services in Shirwal that cover residential clusters and shift-based schedules. With options ranging from 20 to 50-seater AC buses, our service ensures punctual pick-up and drop for factory and office workers. GPS tracking, route optimization, and strict safety protocols make us a trusted partner for daily employee transport."
    },
    {
      "name": "Corporate Office Commute Shirwal",
      "description": "Make daily office commutes hassle-free with eTravo’s corporate transport solutions in Shirwal. We provide scheduled cab and bus services to ferry employees from homes to workplaces and back, improving staff punctuality and retention. Our service plans are customized to fit company size, shift patterns, and transport budgets, making us ideal for growing and established firms alike."
    },
    {
      "name": "Reliable Bus Hire for Corporate Use in Shirwal",
      "description": "eTravo offers dependable bus hire options for corporate use in Shirwal. Whether you need transport for training programs, site visits, or regular staff movement, our buses are equipped with comfortable seating, AC, and driven by experienced chauffeurs. With options for both short and long-term rentals, we ensure safe, professional, and cost-effective travel."
    },
    {
      "name": "AC Cab and Bus Transport for Shirwal MIDC",
      "description": "Experience comfort and efficiency with eTravo’s AC cab and bus transport services in Shirwal MIDC. From daily employee shuttles to executive cab bookings, we provide vehicles that match your exact needs. Our AC fleet is ideal for Pune-Shirwal commuting, intra-zone travel, or managing large factory shifts, all with consistent support and service reliability."
    },
    {
      "name": "Corporate Transport Services for Factory Units Shirwal",
      "description": "eTravo delivers full-scale transport solutions for factory units in Shirwal, including regular staff shuttles, cab hire for supervisors, and logistics support for workforce transfers. We understand the dynamics of factory operations and offer transport that aligns with your shift timings, workforce scale, and budget—ensuring productivity with every ride."
    }
  ],
  "tableData": [
    ["Corporate Cab & Bus Rental Shirwal MIDC", "Employee Shuttle Buses for Industries in Shirwal"],
    ["Corporate Office Commute Shirwal", "Reliable Bus Hire for Corporate Use in Shirwal"],
    ["AC Cab and Bus Transport for Shirwal MIDC", "Corporate Transport Services for Factory Units Shirwal"]
  ],






"whychoose": [
    {
        "WhyChooseheading": "Reliable Transport Solutions for Shirwal MIDC",
        "WhyChoosedescription": "Shirwal MIDC is a rapidly developing industrial area, and eTravo offers dependable cab and bus services tailored to the transport needs of corporate clients operating here. We ensure on-time pickups, safe commuting, and efficient route management to support daily employee movement and executive travel."
    },
    {
        "WhyChooseheading": "Fleet Designed for Industrial Workforce & Executives",
        "WhyChoosedescription": "Our fleet includes a range of well-maintained vehicles—from AC buses for large groups to executive sedans and SUVs for senior staff and client travel. All vehicles are equipped with comfortable seating, air conditioning, and real-time tracking for a smooth and professional experience."
    },
    {
        "WhyChooseheading": "Shift-Based Cab & Bus Services with Flexible Scheduling",
        "WhyChoosedescription": "eTravo specializes in shift-based corporate transport for industrial hubs like Shirwal MIDC. Whether your business runs day shifts, night operations, or round-the-clock production, we provide flexible and scalable scheduling to keep your workforce mobile at all hours."
    },
    {
        "WhyChooseheading": "Trained Drivers with Route Knowledge and Etiquette",
        "WhyChoosedescription": "Our drivers are not only licensed and background-verified but also familiar with the roads, entry gates, and checkpoints in and around Shirwal MIDC. They follow proper corporate protocols, ensuring safe, respectful, and timely transportation for all employees and guests."
    },
    {
        "WhyChooseheading": "Transparent Pricing with Corporate Billing Support",
        "WhyChoosedescription": "We provide clear, upfront pricing with no hidden fees. eTravo supports GST-compliant invoicing, monthly billing cycles, and customizable transport packages—making it easier for HR and admin teams to manage transport expenses efficiently and predictably."
    },
    {
        "WhyChooseheading": "Safety and Hygiene as Top Priorities",
        "WhyChoosedescription": "All vehicles undergo regular maintenance, deep cleaning, and are equipped with safety features like GPS tracking, fire extinguishers, emergency kits, and seat belts. Our commitment to hygiene and safety ensures that your employees commute with complete peace of mind."
    },
    {
        "WhyChooseheading": "24/7 Transport Coordination and Support",
        "WhyChoosedescription": "We understand that industrial operations don’t follow a 9-to-5 schedule. That’s why eTravo offers 24/7 support and real-time ride tracking to help you manage shift changes, emergency transport needs, or unexpected logistics—anytime, day or night."
    },
    {
        "WhyChooseheading": "Customized Transport Solutions for Growing Industries",
        "WhyChoosedescription": "Every company in Shirwal MIDC has different needs. Whether you're moving 20 or 200 employees, or require daily routes or on-demand rides, eTravo customizes transport plans to match your exact business goals and employee schedules. We grow with you."
    }
]






























    }

// Corporate Cab and Bus Services in Shirwal MIDC – eTravo

const faqData = [
    [
        {
            question: 'What corporate transportation solutions does eTravo offer in Shirwal MIDC?',
            answer: 'eTravo offers reliable cab and bus services in Shirwal MIDC tailored for industrial and corporate clients, including daily employee transport, executive cab services, and shift-based travel solutions.',
        },
        {
            question: 'Can eTravo handle multi-shift employee transport for factories in Shirwal MIDC?',
            answer: 'Yes, we specialize in managing transport for manufacturing units operating in multiple shifts. We provide punctual pickups and drops, along with route optimization and 24/7 fleet availability.',
        },
        {
            question: 'What vehicle options are available for companies in Shirwal MIDC?',
            answer: 'Our fleet includes hatchbacks, sedans, SUVs for executives, tempo travellers, and AC buses (13–50 seaters) — all maintained regularly and equipped for industrial zone transport needs.',
        },
        {
            question: 'Are safety protocols and GPS tracking included with your services?',
            answer: 'Yes, all vehicles come with GPS tracking, verified drivers, and compliance with corporate safety norms. Clients can monitor routes and receive detailed transport reports.',
        },
        {
            question: 'Can we book eTravo for site visits, inspections, or corporate events from Shirwal?',
            answer: 'Absolutely. eTravo offers flexible transport services for outstation meetings, vendor visits, plant inspections, and corporate events, with full coordination and support.',
        },
        {
            question: 'Is there account-level support for corporate clients in Shirwal MIDC?',
            answer: 'Yes, we assign a dedicated account manager to every client to handle bookings, scheduling, route planning, compliance, and ongoing support for seamless transport operations.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Shrikant More',
        designation: 'Plant Admin, Orion Components Pvt. Ltd.',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo has helped us streamline employee travel in Shirwal MIDC. Their buses and cabs are clean, on time, and perfectly suited for shift-based factory operations.”',
    },
    {
        name: 'Ms. Leena Jagtap',
        designation: 'HR Coordinator, NexTech Polymers',
        rating: [1, 1, 1, 1, 1],
        text: '“We’ve relied on eTravo for over a year for our Shirwal unit. Their team is responsive, and their transport service is smooth and safe — great for industrial environments.”',
    },
];














    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab and Bus Services in Shirwal MIDC",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-bus-service-shirwal-midc.jpg",
  "description": "Reliable corporate cab and bus services in Shirwal MIDC by eTravo. Ideal for employee shuttle buses, factory units transport, and corporate office commute with affordable AC vehicles and professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.6",
    "ratingCount": "1420"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-and-bus-services-in-shirwal-midc"
  }
};




    return (
        <div>


<Helmet>
  <title>Corporate Cab and Bus Services in Shirwal MIDC | Employee Shuttle & Factory Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cab and bus services in Shirwal MIDC with eTravo for employee shuttle, factory transport, and office commute. Affordable AC vehicles with reliable service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/17.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabandbusserviceinshirwal;